import { useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { routes } from "../../routes/routes";
import { getUserAvatar } from "../../utils/getMedia";
import Header from "../Header";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { usePromoterSelectedGroup } from "../../hooks/usePromoterSelectedGroup";
import ReactiveButton from "reactive-button";
import AuthClient from "../../api/AuthClient";
import RequestBetterPhotosApi from "../../api/RequestBetterPhotosApi";
import GroupStatus from "../../api/enums/GroupStatus";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const CarouselView = () => {
  const { city, groupId } = useParams();
  const { selectedGroup, requestState } = usePromoterSelectedGroup(groupId);
  const [requestBetterPhotosState, setRequestBetterPhotosState] = useState<'idle' | 'loading' | 'success' | 'error'>("idle");

  const navigate = useNavigate();
  const authClient = new AuthClient();

  const MakeOffer = (groupId: string, city: string | undefined) => {
    navigate(routes.MakeOffer(city, groupId), {
      state: {
        returnTo: routes.PromGroupDetailPage(city ?? "", groupId),
      },
    });
  };

  const requestBetterPhotos = async () => {
    if (!groupId || requestBetterPhotosState === "loading") {
      return;
    }

    const api = new RequestBetterPhotosApi(authClient);

    try {
      setRequestBetterPhotosState("loading");
      const response = await api.requestBetterPhotos(groupId);

      if (!response || response.statusCode >= 400) {
        throw new Error("Failed to request better photos.");
      }

      setRequestBetterPhotosState("success");
    } catch (error) {
      console.error("Failed to request better photos:", error);
      setRequestBetterPhotosState("error");
      toast.error("Failed to request better photos.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const invitations = useMemo(
    () => selectedGroup?.invitations ?? [],
    [selectedGroup]
  );
  const shouldShowPromoterActions = selectedGroup?.party?.status === GroupStatus.Looking;

  return (
    <>
      <Header />
      <div className="centerGroup">
        <div className="desktopUI">
          <div className="row userProfile_Header">
            <Breadcrumbs to={routes.PromotersMode} />
            <div className="d-flex justify-content-end space col-6 d-flex-gap-5">
              {shouldShowPromoterActions ? (
                <>
                  <ReactiveButton
                    buttonState={requestBetterPhotosState}
                    onClick={() => { void requestBetterPhotos(); }}
                    color={'red'}
                    idleText={'REQUEST BETTER PHOTOS'}
                    loadingText={'REQUESTING'}
                    successText={'REQUESTED'}
                    errorText={'ERROR'}
                    type={'button'}
                    //style={{ borderRadius: '20px', color: 'white', border: '1px solid #dc3545' }}
                    className="btn btn-sm btn-outline-danger"
                    outline={true}
                    shadow={false}
                    rounded={false}
                    size={'small'}
                    block={false}
                    messageDuration={2000}
                    disabled={requestBetterPhotosState === "loading" || !groupId}
                    buttonRef={null}
                    width={null}
                    height={null}
                    animation={true}
                  />
                  <button
                    className="btn btn-sm btn-outline-warning"
                    onClick={() => { groupId ? MakeOffer(groupId, city) : MakeOffer("", "") }}>
                    Make Offer
                  </button>
                </>
              ) : null}
            </div>
          </div>
          {invitations.length > 0 ? (
            <div>
              <div className="groupPromoter">
                <div className="desktopUI">
                  <Carousel
                    className={`row mt-4 swipe-container`}
                    swipeable
                    emulateTouch
                    showArrows={false}
                    infiniteLoop={true}
                    showStatus={false}
                    renderIndicator={() => null}
                    swipeScrollTolerance={100}
                    showThumbs={false}
                  >
                    {invitations.map((invitation, index) => (
                      <div key={invitation.id} className="carousel-slide p-0 m-0">
                        <div className="col-12">
                          <p className="yellowTxt m-0">Age: {invitation.age}</p>
                          <p className="yellowTxt m-0">
                            Tap on the picture to enable pinch zoom
                          </p>
                          <p className="yellowTxt">Swipe to see next guest</p>
                        </div>

                        <div className="col-12 justify-content-center align-content-center p-0">
                          <div className="promoter-imageContainer">

                            {Array.from({ length: invitation.photos }, (_, i) => (
                              <Link to={routes.PhotoZoom("group-detail", city ? city : "0", groupId ? groupId : invitation.id, `${index}?photo=${getUserAvatar(
                                i === 0 ? invitation?.id! : `${invitation?.id!}${i}`)}`)} key={index}>

                                <img
                                  key={index + i}
                                  src={getUserAvatar(
                                    i === 0
                                      ? invitation?.id!
                                      : `${invitation?.id!}${i}`
                                  )}
                                  alt=""
                                  style={{ pointerEvents: "all" }}
                                  className="p-0 m-0 groupDetailImg"
                                />
                              </Link>
                            ))}

                          </div>
                        </div>
                      </div>
                    ))}
                  </Carousel>                  
                </div>
              </div>
            </div>
          ) : requestState === "loading" || requestState === "idle" ? (
            <p>Loading group...</p>
          ) : requestState === "error" ? (
            <p>Group not found.</p>
          ) : (
            <p>Invitation not found.</p>
          )}
        </div>
      </div>
      <ToastContainer
        progressClassName="toastProgress"
        bodyClassName="toastBody"
      />
    </>
  );
};

export default CarouselView;
